import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const state={
	openId:'',
}
export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
	strict:debug,
	plugins: [createPersistedState()]
})


// WEBPACK FOOTER //
// ./src/store/index.js